import React from "react";
import outline from "../assets/icons/footer-01.svg";
import footer_img from "../assets/images/footer.jpg";
import { Mail, MapPin, Phone, SendHorizonal } from "lucide-react";
import { Link } from "react-router-dom";
import instagram from "../assets/icons/instagram (2).png";
import facebook from "../assets/icons/facebook (2).png";
import linkedin from "../assets/icons/linkedin-sign.png";
import youtube from "../assets/icons/play.png";

const Footer = () => {
  const footerLinks = [
    {
      title: "Home",
      url: "/",
    },
    {
      title: "About",
      url: "/about-me",
    },
    {
      title: "Specialities",
      url: "/specialities",
    },
    {
      title: "Blogs",
      url: "/blogs",
    },
    {
      title: "Contact",
      url: "/contact-me",
    },
    {
      title: "Privacy Policy",
      url: "/contact-me",
    },
    {
      title: "Patient Resources",
      url: "/contact-me",
    },
  ];

  const socialMedial = [
    {
      icon: instagram,
      url: "https://www.instagram.com/dr.hemanthmakineni/",
    },

    {
      icon: facebook,
      url: "https://www.facebook.com/drhemanthmakineni/",
    },

    {
      icon: linkedin,
      url: "https://www.linkedin.com/in/hemanth-makineni-3b299752/",
    },

    {
      icon: youtube,
      url: "https://youtube.com",
    },
  ];
  return (
    <div className=" relative bg-almond/95 ">
      <div className="md:top-20 bottom-0 left-0 w-full px-10  absolute">
        <img
          src={outline}
          alt="outline"
          className="pointer-events-none w-full"
        />
      </div>
      <div className="xl:w-[1280px] xl:px-10 px-0 w-11/12 mx-auto flex justify-center items-center flex-col z-10">
        <div className="max-w-5xl md:rounded-br-3xl md:rounded-bl-3xl rounded-br-xl rounded-bl-xl relative overflow-hidden md:h-52 h-56 mb-10">
          <img
            src={footer_img}
            className="w-full h-full md:w-auto md:h-auto object-cover"
            alt=""
          />
          <div className="top-0 absolute w-full h-full bg-matcha/90" />
          <div className="top-0 absolute w-full h-full flex md:flex-row flex-col md:justify-between justify-center lg:px-10 md:py-0 py-8 px-4 lg:gap-10 gap-2 items-center">
            <div className="md:w-1/2 w-full">
              <h4 className="md:text-2xl text-xl font-bold text-white">
                Subscribe Our Newsletter
              </h4>
              <p className="text-base text-white font-normal py-3 xl:w-11/12">
                Get easy, actionable neurology and brain health tips delivered
                straight to your inbox every week.
              </p>
            </div>
            <div className="md:w-1/2 w-full relative">
              <input
                type="email"
                placeholder="Enter Your Email"
                className="w-full text-base text-white font-normal placeholder:text-white py-2 ps-3 pe-10 mt-1 bg-transparent outline-none border-b border-almond focus:border-white"
              />
              <button className="right-0 hover:text-carob transition duration-300 w-10 hover:-rotate-45 absolute flex justify-center items-center text-white top-3">
                <SendHorizonal />
              </button>
            </div>
          </div>
        </div>
        <div className="max-w-5xl  relative">
          <div className=" flex flex-row justify-center items-center gap-1 md:gap-x-4 md:gap-y-4 flex-wrap">
            {footerLinks.map((item) => (
              <Link
                to={item.url}
                key={crypto.randomUUID()}
                className=" py-2 md:min-w-40 px-2 text-lg md:text-xl text-[#B87333]  font-semibold flex flex-row items-center justify-center gap-4 rounded-xl hover:bg-matcha  hover:text-white duration-200 transition"
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
        <div className="flex flex-row md:gap-8 gap-4 justify-between flex-wrap w-full relative my-8">
          <div className="flex flex-row gap-3 h-12 flex-shrink-0">
            <div className="flex justify-center rounded-lg items-center flex-shrink-0 w-12 h-12 bg-matcha text-white p-2">
              <Mail size={18} />
            </div>
            <div className="flex flex-col justify-between">
              <p className="text-base font-bold text-[#B87333] ">Email</p>
              <a
                href="mailto:drhemanth@gmail.com"
                className="text-base font-semibold text-matcha hover:border-b-2 hover:border-matcha duration-300 transition"
              >
                drhemanth@gmail.com
              </a>
            </div>
          </div>
          <div className="flex flex-row gap-3 h-12 flex-shrink-0">
            <div className="flex justify-center rounded-lg  items-center flex-shrink-0 w-12 h-12 bg-matcha text-white p-2">
              <Phone size={18} />
            </div>
            <div className="flex flex-col justify-between">
              <p className="text-base font-bold text-[#B87333] ">Phone</p>
              <a
                href="tel:+917894504321"
                className="text-base font-semibold hover:border-b-2 text-matcha hover:border-matcha duration-300 transition"
              >
                +91 78945 04321
              </a>
            </div>
          </div>
          <div className="flex flex-row gap-3 h-12">
            <div className="flex justify-center rounded-lg items-center flex-shrink-0 w-12 h-12 bg-matcha text-white p-2">
              <MapPin size={18} />
            </div>
            <div className="flex flex-col justify-between">
              <p className="text-base font-bold text-[#B87333] ">Address</p>
              <a
                href="https://maps.app.goo.gl/2Z81z9qtx4VTXza26"
                rel="noopener noreferrer"
                target="_blank"
                className="text-base font-semibold text-matcha hover:border-b-2  text-wrap hover:border-matcha duration-300 transition"
              >
                Arka Hospital & Research Institute, Guntur
              </a>
            </div>
          </div>
          <p className="text-base flex flex-row gap-3 text-[#B87333]  font-normal py-3 mt-3 md:mt-0">
            {socialMedial.map((item, index) => (
              <a
                key={crypto.randomUUID()}
                className="bg-matcha flex hover:bg-[#B87333]   border-dashed border border-pistache transition justify-center items-center p-2 rounded-full"
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <img src={item.icon} className=" w-5 " alt="" />
              </a>
            ))}
          </p>
        </div>
        <div className="w-full border-t border-[#B87333]  text-center py-5">
          <p className="text-base text-matcha relative font-normal">
            © 2026 Dr Hemanth. All rights reserved - Powered by{" "}
            <a
              href="https:novatales.com"
              className="hover:border-b hover:border-matcha"
              target="_blank"
              rel="noreferrer"
            >
              NovaTales
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
